var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalloutsDirectionSetterBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.835 18.665L12.835 15.4923L14.75 13.5773L16.665 15.4923L16.665 18.665L12.835 18.665Z",
    stroke: "black",
    strokeWidth: 1.17
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11H19.75",
    stroke: "black",
    strokeWidth: 1.17
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalloutsDirectionSetterBottom);
export default __webpack_public_path__ + "static/media/callouts-direction-setter-bottom.524e0734ba124dd63779b1f520476ab3.svg";
export { ForwardRef as ReactComponent };